/* eslint-disable react/prop-types */
import { Row, Spin } from 'antd';
import { getEstadosGlobales, getPeriodicidadesDePagos } from 'api/catalogos';
import { getTiposDeNominasEmpleados, putTipoDeNominaEmpleado } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { checkToken } from 'api/utils';
import ModalConfirmPrenomina from 'components/ModalConfirmPrenomina';
import Table from 'components/Table';
import React, { useEffect, useState } from 'react';
import { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';

const CierreDePrenomina = ({ permission }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [estadosGlobales, setEstadosGlobales] = useState([]);
  const [periodicidades, setPeriodicidades] = useState([]);
  const [visibleHabilitar, setVisibleHabilitar] = useState(false);
  const [visibleCerrar, setVisibleCerrar] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const _data = await getTiposDeNominasEmpleados();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estadosGlobales,
        _periodicidades,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPeriodicidadesDePagos(),
        getTiposDeNominasEmpleados(),
      ]);
      if (mounted) {
        setEstadosGlobales(_estadosGlobales);
        setPeriodicidades(_periodicidades);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onClickTrue = async () => {
    try {
      setLoading(true);
      const mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
        id: val, habilitado: true,
      }));
      const saved = await putTipoDeNominaEmpleado(mappedSelectedRowKeys);
      if (saved) {
        await fetchData();
      }
    } catch (err) {
      onError(err, setLoading);
    }
    setLoading(false);
    setVisibleHabilitar(false);
    setSelectedRowKeys([]);
  };

  const onClickFalse = async () => {
    try {
      setLoading(true);
      const mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
        id: val, habilitado: false,
      }));
      const saved = await putTipoDeNominaEmpleado(mappedSelectedRowKeys);
      if (saved) {
        await fetchData();
      }
    } catch (err) {
      onError(err, setLoading);
    }
    setLoading(false);
    setVisibleCerrar(false);
    setSelectedRowKeys([]);
  };

  const handleOnRowClick = (record) => {
    if (selectedRowKeys.includes(record.id)) {
      setSelectedRowKeys(selectedRowKeys.filter((key) => key !== record.id));
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleSelectAll = (_, selectedRows, __) => {
    setSelectedRowKeys(selectedRows.map((row) => row.id));
  };

  const rowSelection = {
    selectedRowKeys,
    onSelectAll: handleSelectAll,
    type: 'checkbox',
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 300,
    },
    {
      titleText: 'Periodicidad',
      dataIndex: 'periodicidad_de_pago',
      key: 'periodicidad_de_pago',
      width: 200,
      render: (val) => periodicidades.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'PreNómina',
      dataIndex: 'habilitado',
      key: 'habilitado',
      width: 200,
      render: (val) => (val ? 'HABILITADO' : 'CERRADO'),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estadosGlobales.find((e) => e.id === val)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          data={data}
          cols={columns}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickTrue: () => setVisibleHabilitar(true),
            onClickFalse: () => setVisibleCerrar(true),
          }}
          allowMultiFalseChanger
          allowMultiTrueChanger
          multiFalseChangerText="Cerrar Pre-Nómina"
          multiTrueChangerText="Habilitar Pre-Nómina"
          allowDoubleClick={false}
          allowExportPDF={false}
          permission={permission}
        />
        {/* Habilitar prenomina */}
        <ModalConfirmPrenomina
          onConfirm={onClickTrue}
          onCancel={() => setVisibleHabilitar(false)}
          cierre={false}
          loading={loading}
          open={visibleHabilitar}
        />
        {/* Cerrar prenomina */}
        <ModalConfirmPrenomina
          onConfirm={onClickFalse}
          onCancel={() => setVisibleCerrar(false)}
          cierre
          loading={loading}
          open={visibleCerrar}
        />
      </Spin>
    </Row>
  );
};

export default CierreDePrenomina;
